module.exports = __webpack_public_path__ + "static/media/mission-vision_card_min.fb153912.jpg";